// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-YJ3OkA{color:#1d1c23;font-size:14px;display:flex}.itemTitle-T8q7Uy{flex:1;align-items:center;display:flex}.itemContent-PfQkiv{align-items:center;display:flex}.close-OXlKao{cursor:pointer;position:absolute;top:24px;right:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `item-YJ3OkA`,
	"itemTitle": `itemTitle-T8q7Uy`,
	"itemContent": `itemContent-PfQkiv`,
	"close": `close-OXlKao`
};
export default ___CSS_LOADER_EXPORT___;
